<template>
  <div>
    <p
      v-for="(answer, index) in answers"
      :key="index"
      class="mb-25"
    >
      <b-radio
        :value="value"
        size="is-small"
        :native-value="answer.value"
        @input="handleInput"
      >{{ answer.label }}</b-radio>
    </p>
  </div>
</template>

<script>
export default {
  name: "QuestionnaireOptions",
  props: {
    value: {},
    answers: {
      type: Object,
      required: true,
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
  }
}
</script>

<style scoped lang="scss">

</style>
